import { requestSuccess } from "@Api";
import { TOGGLE_SIDEBAR } from "@Actions/types";

const toggleSidebar = () => {
	return (dispatch) => {
		dispatch(requestSuccess(TOGGLE_SIDEBAR));
	};
};

export default toggleSidebar;
